import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 10vh;
  padding: ${(props) => (props.padding ? props.padding : "1em")};
`;
export const Icons = styled.span`
  margin: 0;
  display: flex;
  align-items: center;

  h3 {
    font-size: 0.8em;
    margin: 0;
    margin-right: 0.5em;
  }

  .ico {
    margin-top: -8px;
    color: #fb5d41;
  }
`;
export const H1 = styled.h4`
  margin: 0;
  padding-left: 0;
`;
